import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import FieldWrapper from "../FieldWrapper";
import PreferredSpecialization from "./PreferredSpecialization";
const PreferredSpecializationWrapper: React.FC = () => {
    const preferredSpecialization = useSelector(
        (state: RootStore) =>
            state.RegistrationLoginPage.signUpPageData?.fields?.preferredSpecializationV1,
    );

    return useMemo(() => {
        if (preferredSpecialization) {
            return (
                <FieldWrapper
                    visible={preferredSpecialization.visible}
                    loading={preferredSpecialization.loading ?? false}
                >
                    <PreferredSpecialization configuration={preferredSpecialization} />
                </FieldWrapper>
            );
        }
        return null;
    }, [preferredSpecialization]);
};
export default PreferredSpecializationWrapper;
